var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoFaSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16H3L6.47 11.34C6.6831 11.1057 6.83752 10.8242 6.92057 10.5186C7.00361 10.213 7.01289 9.89203 6.94766 9.58214C6.88242 9.27225 6.74453 8.98228 6.54532 8.73609C6.34612 8.48991 6.09131 8.29455 5.80185 8.16608C5.51239 8.03762 5.19657 7.97973 4.88036 7.99718C4.56416 8.01463 4.25662 8.10691 3.98306 8.26644C3.70949 8.42597 3.47771 8.64818 3.30681 8.91479C3.1359 9.18139 3.03075 9.48477 3 9.79996M10 16V7.99996H14M10 12H13M17 16V9.99996C17 9.46953 17.2107 8.96082 17.5858 8.58575C17.9609 8.21067 18.4696 7.99996 19 7.99996C19.5304 7.99996 20.0391 8.21067 20.4142 8.58575C20.7893 8.96082 21 9.46953 21 9.99996V16M17 13H21",
    stroke: "#00332D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFaSelected);
export default __webpack_public_path__ + "static/media/twoFaSelected.f854ef739821b1ed8d48c7eb6244b523.svg";
export { ForwardRef as ReactComponent };